import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from '@zillow/constellation';
import BodySectionList from './BodySectionList';
import BodySectionForm from './BodySectionForm';
import BodySectionRichText from './BodySectionRichText';

export default function LegalComplianceWallBodySection({ text, richText, form, textList, setFormAnswer }) {
  if (text) {
    return <Paragraph marginBottom="md">{text}</Paragraph>;
  }

  if (richText) {
    return <BodySectionRichText richText={richText} />;
  }

  if (form) {
    return <BodySectionForm {...{ form, setFormAnswer }} />;
  }

  if (textList) {
    return <BodySectionList list={textList} />;
  }

  return null;
}

LegalComplianceWallBodySection.displayName = 'LegalComplianceWallBodySection';

LegalComplianceWallBodySection.propTypes = {
  text: PropTypes.string,
  richText: PropTypes.array,
  form: PropTypes.shape({
    id: PropTypes.string.isRequired,
    options: PropTypes.array,
  }),
  textList: PropTypes.arrayOf(PropTypes.string),
  setFormAnswer: PropTypes.func,
};
